/* JS trang SP, tách khỏi sections/main-product.liquid 04/11. NJOY_SID = section.id, gán ngay trước thẻ nạp file này. */
(function() {
  function njoyMoveInfoAbove() {
    var grid = document.querySelector('.section-' + NJOY_SID + '-padding .product.grid');
    if (!grid) return;
    var container = grid.querySelector('.product__info-container');
    if (!container) return;
    var titleEl = container.querySelector('.product__title');
    var statBarEl = container.querySelector('.njoy-stat-bar');
    var priceEl = container.querySelector('[id^="price-"]');
    if (!titleEl && !priceEl) return;
    var preview = document.createElement('div');
    preview.className = 'njoy-info-preview';
    if (titleEl) preview.appendChild(titleEl);
    if (statBarEl) preview.appendChild(statBarEl);
    if (priceEl) preview.appendChild(priceEl);
    grid.parentNode.insertBefore(preview, grid);
  }

  // ── Bấm vào thanh rating/lượt bán → cuộn mượt xuống section review (không phải modal) ──
  function njoyScrollToReviews(e) {
    var trigger = e.target.closest('[data-njoy-scroll-reviews]');
    if (!trigger) return;
    e.preventDefault();
    if (window.njoyOpenReviews) { window.njoyOpenReviews(); return; }
    var target = document.getElementById('njoy-product-reviews');
    if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
  document.addEventListener('click', njoyScrollToReviews);
  document.addEventListener('keydown', function (e) {
    if ((e.key === 'Enter' || e.key === ' ') && e.target.closest('[data-njoy-scroll-reviews]')) {
      njoyScrollToReviews(e);
    }
  });

  function njoyBuildGallery() {

    // ── Data ──
    var mediaData, variantData;
    try {
      mediaData  = JSON.parse(document.getElementById('NjoyMediaData-' + NJOY_SID + '').textContent);
      variantData = JSON.parse(document.getElementById('NjoyVariantData-' + NJOY_SID + '').textContent);
    } catch(e) { return; }
    if (!mediaData || !mediaData.length) return;
    if (window.njoyLocAnhHet) { var _loc = njoyLocAnhHet(mediaData, variantData); mediaData = _loc.m; variantData = _loc.v; }

    // ── Video luôn hiển thị trước tiên (Nick chốt) — sort ổn định, chỉ đổi vị trí video lên đầu ──
    mediaData.sort(function(a, b) {
      var aVid = (a.media_type === 'video' || a.media_type === 'external_video') ? 0 : 1;
      var bVid = (b.media_type === 'video' || b.media_type === 'external_video') ? 0 : 1;
      return aVid - bVid;
    });

    // ── Video detection helpers ──

    window.njoyIsVideoSlide = function(slideEl) {
      // Dùng media_type từ dataset nếu có (reliable hơn src pattern)
      if (slideEl.dataset.mediaType) return slideEl.dataset.mediaType !== 'image';
      var img = slideEl.querySelector('img');
      if (!img) return false;
      var src = img.src || img.getAttribute('src') || '';
      return src.indexOf('/preview_images/') !== -1 && src.indexOf('.thumbnail.') !== -1;
    }

    var _njoyVideoMap = null;
    window.njoyGetVideoMap = function() {
      if (_njoyVideoMap) return _njoyVideoMap;
      _njoyVideoMap = {};
      var mg = document.querySelector('media-gallery');
      if (!mg) return _njoyVideoMap;
      mg.querySelectorAll('deferred-media[data-media-id]').forEach(function(d) {
        var dawnId = d.dataset.mediaId;
        var tmpl = d.querySelector('template');
        if (!tmpl) return;
        var tempDoc = new DOMParser().parseFromString(tmpl.innerHTML, 'text/html');
        var firstSource = tempDoc.querySelector('source');
        var vidEl = tempDoc.querySelector('video');
        if (firstSource) {
          _njoyVideoMap[dawnId] = {
            src: firstSource.src,
            type: firstSource.type || 'video/mp4',
            poster: vidEl ? (vidEl.getAttribute('poster') || '') : '',
            sources: Array.from(tempDoc.querySelectorAll('source')).map(function(s) {
              return { src: s.src, type: s.type || 'video/mp4' };
            })
          };
        }
      });
      return _njoyVideoMap;
    }

    window.njoyGetVideoData = function(slideEl) {
      var mediaId = slideEl.dataset.mediaId || '';
      var dawnId = mediaId.split('-').pop();
      var map = njoyGetVideoMap();
      return map[dawnId] || null;
    }

    // ── Gallery container — insert trước .product.grid ──
    var pageWidth = document.querySelector('.section-' + NJOY_SID + '-padding .page-width');
    var grid = pageWidth && pageWidth.querySelector('.product.grid');
    if (!grid) return;

    var gl = document.createElement('div');
    gl.id = 'NjoyGL-' + NJOY_SID + '';
    gl.className = 'njoy-gl';
    pageWidth.insertBefore(gl, grid);

    // ── Build slides ──
    var slides = mediaData.map(function(media, i) {
      var slide = document.createElement('div');
      slide.className = 'njoy-gl__slide' + (i === 0 ? ' is-active' : '');
      slide.dataset.mediaId = media.id;
      if (media.media_type) slide.dataset.mediaType = media.media_type;

      // Slide video đầu tiên (i===0) — autoplay ngay, không cần bấm mở lightbox (Nick chốt).
      var isVideoType = media.media_type === 'video' || media.media_type === 'external_video';
      if (i === 0 && isVideoType) {
        var vidData = njoyGetVideoData(slide);
        if (vidData) {
          var videoEl = document.createElement('video');
          videoEl.className = 'njoy-gl__video';
          videoEl.autoplay = true; videoEl.muted = true; videoEl.defaultMuted = true; videoEl.loop = true;
          videoEl.setAttribute('muted', ''); videoEl.setAttribute('autoplay', '');
          videoEl.preload = 'auto';
          videoEl.playsInline = true; videoEl.setAttribute('playsinline', '');
          videoEl.poster = media.src || vidData.poster || '';
          // Load nhanh hơn: chỉ nhúng bản bitrate THẤP NHẤT cho slide nhỏ tự động phát này
          // (Shopify tự xuất nhiều mức chất lượng, tên file có dạng "...-7.2Mbps-...").
          // Lightbox (bấm mở xem lớn) vẫn dùng nguyên vidData.sources đầy đủ, không đụng.
          var allSources = vidData.sources || [{ src: vidData.src, type: vidData.type }];
          var lowestSource = allSources[0];
          var lowestMbps = Infinity;
          allSources.forEach(function(s) {
            var m = s.src.match(/(\d+(?:\.\d+)?)Mbps/i);
            var mbps = m ? parseFloat(m[1]) : Infinity;
            if (mbps < lowestMbps) { lowestMbps = mbps; lowestSource = s; }
          });
          var sourceEl = document.createElement('source');
          sourceEl.src = lowestSource.src; sourceEl.type = lowestSource.type;
          // Theme chỉ nhận được bản 1080p (21 MB mỗi lần mở trang, đo 03/11). Shopify có sẵn bản 480p cùng tên: thử trước, không có thì trình duyệt tự dùng bản gốc.
          var ban480 = lowestSource.src.replace(/(?:HD|SD)-\d+p-[\d.]+Mbps/, 'SD-480p-1.5Mbps');
          if (ban480 !== lowestSource.src) {
            var s480 = document.createElement('source');
            s480.src = ban480; s480.type = 'video/mp4';
            videoEl.appendChild(s480);
          }
          videoEl.appendChild(sourceEl);
          slide.appendChild(videoEl);
          gl.appendChild(slide);
          /* Thuộc tính autoplay có lúc không chạy: đo 04/11, 1/9 lần tải xong vẫn đứng ở giây 0; quay lại trang bằng nút lùi cũng dừng; iPhone tiết kiệm pin chặn tới lần chạm đầu. Gọi play() mỗi khi có cơ hội. */
          var chayVideo = function() {
            if (!videoEl.paused || !slide.classList.contains('is-active')) return;
            var p = videoEl.play();
            if (p && p.catch) p.catch(function() {});
          };
          videoEl.njoyChay = chayVideo;
          ['loadedmetadata', 'loadeddata', 'canplay'].forEach(function(ev) { videoEl.addEventListener(ev, chayVideo); });
          [300, 1000, 2500].forEach(function(ms) { setTimeout(chayVideo, ms); });
          window.addEventListener('load', chayVideo);
          window.addEventListener('pageshow', chayVideo);
          document.addEventListener('visibilitychange', function() { if (!document.hidden) chayVideo(); });
          document.addEventListener('touchend', chayVideo, { passive: true });
          document.addEventListener('click', chayVideo);
          return slide;
        }
      }

      var img = document.createElement('img');
      img.alt     = media.alt || '';
      if (media.w && media.h) { img.width = media.w; img.height = media.h; }
      if (media.srcset) img.sizes = media.sizes || '(max-width: 749px) 100vw, 600px';
      // Các slide xếp chồng nên loading=lazy vô tác dụng, cả gallery tải cùng lúc. Chỉ nạp ảnh đầu, còn lại qua napAnh.
      if (i === 0) {
        img.setAttribute('fetchpriority', 'high');
        if (media.srcset) img.srcset = media.srcset;
        img.src = media.src;
      } else {
        if (media.srcset) img.dataset.srcset = media.srcset;
        img.dataset.src = media.src;
      }
      slide.appendChild(img);
      gl.appendChild(slide);
      return slide;
    });

    // ── Gallery height: vuông trên mobile, cap 570px tablet+ (Nick chốt; KHÔNG cap max-width: thừa trắng bên phải) ──
    function setSquare() {
      var w = gl.offsetWidth;
      if (w <= 0) return;
      var h = w;
      if (window.innerWidth >= 750) h = Math.min(h, 570);
      gl.style.height = h + 'px';
    }
    setSquare();
    window.addEventListener('resize', setSquare);

    // ── Nạp ảnh slide khi cần ──
    function napAnh(i) {
      var im = slides[i] && slides[i].querySelector('img[data-src]');
      if (!im) return;
      if (im.dataset.srcset) im.srcset = im.dataset.srcset;
      im.src = im.dataset.src;
      im.removeAttribute('data-src');
      im.removeAttribute('data-srcset');
    }
    function napHet() { slides.forEach(function(_, i) { napAnh(i); }); }
    gl.addEventListener('touchstart', napHet, { passive: true, once: true });
    gl.addEventListener('mouseenter', napHet, { once: true });
    if (document.readyState === 'complete') napAnh(1);
    else window.addEventListener('load', function() { napAnh(1); });

    // ── State ──
    var current = 0;
    var thumbsEl = null; // set sau khi build

    function goTo(idx) {
      if (idx === current || idx < 0 || idx >= slides.length) return;
      var vCu = slides[current].querySelector('video.njoy-gl__video');
      if (vCu) vCu.pause();
      slides[current].classList.remove('is-active');
      if (thumbsEl && thumbsEl.children[current]) thumbsEl.children[current].classList.remove('is-active');
      current = idx;
      napAnh(idx); napAnh(idx + 1); napAnh(idx - 1);
      slides[current].classList.add('is-active');
      var vMoi = slides[current].querySelector('video.njoy-gl__video');
      if (vMoi && vMoi.njoyChay) vMoi.njoyChay();
      if (thumbsEl && thumbsEl.children[current]) thumbsEl.children[current].classList.add('is-active');
      updateDots(current);
    }

    // ── Dots: pill đè lên ảnh, nằm TRONG .njoy-gl; chỉ hiện tối đa NJOY_DOTS_WINDOW chấm quanh ảnh đang xem ──
    var NJOY_DOTS_WINDOW = 5;
    var dots = null, soEl = null;
    if (slides.length > 1) {
      dots = document.createElement('div');
      dots.className = 'njoy-gl__dots';
      slides.forEach(function(_, i) {
        var d = document.createElement('span');
        d.className = 'njoy-gl__dot' + (i === 0 ? ' is-active' : '');
        dots.appendChild(d);
      });
      gl.appendChild(dots);
      soEl = document.createElement('div');
      soEl.className = 'njoy-gl__so';
      gl.appendChild(soEl);
      updateDots(0);
    }

    function updateDots(idx) {
      if (!dots) return;
      if (soEl) soEl.textContent = (idx + 1) + '/' + slides.length;
      var dotEls = dots.querySelectorAll('.njoy-gl__dot');
      var total = dotEls.length;
      var half = Math.floor(NJOY_DOTS_WINDOW / 2);
      var start = Math.max(0, Math.min(idx - half, total - NJOY_DOTS_WINDOW));
      var end = start + NJOY_DOTS_WINDOW - 1;
      dotEls.forEach(function(d, i) {
        d.classList.toggle('is-active', i === idx);
        d.classList.toggle('is-hidden', i < start || i > end);
      });
    }

    // ── Desktop thumbnail strip (hiển thị tại 750px+) ──
    thumbsEl = document.createElement('div');
    thumbsEl.className = 'njoy-gl__thumbs';
    mediaData.forEach(function(media, i) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'njoy-gl__thumb' + (i === 0 ? ' is-active' : '');
      btn.dataset.idx = i;
      var tImg = document.createElement('img');
      tImg.loading = 'lazy';
      tImg.sizes = '80px';
      if (media.srcset) tImg.srcset = media.srcset;
      tImg.src = media.src;
      tImg.alt = media.alt || '';
      btn.appendChild(tImg);
      btn.addEventListener('click', function() { goTo(parseInt(this.dataset.idx, 10)); });
      thumbsEl.appendChild(btn);
    });

    // ── Mark video slides + thumbnails — bỏ qua slide đã tự render <video> autoplay
    // (không cần overlay "bấm để phát" đè lên video đang chạy sẵn) ──
    slides.forEach(function(slide, i) {
      if (njoyIsVideoSlide(slide) && !slide.querySelector('video')) {
        slide.dataset.isVideo = 'true';
        var thumb = thumbsEl.querySelector('.njoy-gl__thumb[data-idx="' + i + '"]');
        if (thumb) thumb.dataset.isVideo = 'true';
      }
    });

    // ── Swipe: ảnh chạy theo ngón tay + khoá hướng (Nick 29/10: vuốt ngang làm cả trang
    // giật lên xuống — bản cũ chỉ đổi ảnh lúc nhấc tay, không chặn cuộn dọc). Cử động đầu
    // ≥5px quyết định hướng (như Swiper): ngang → preventDefault suốt cử chỉ (touchmove KHÔNG
    // passive; iOS chỉ cho chặn trước khi trang bắt đầu cuộn); dọc → để trang cuộn bình thường. ──
    var sw = null, swHang = null;   // swHang: hiệu ứng 0.25s đang chờ chốt
    function swPos(el, x, anim) {
      el.style.transition = anim ? 'transform 0.25s ease' : 'none';
      el.style.transform = 'translateX(' + x + 'px)';
    }
    function swClear(el) { el.style.transition = el.style.transform = el.style.opacity = el.style.zIndex = ''; }
    function swSau(fn) { swHang = { fn: fn, t: setTimeout(swChot, 260) }; }
    // Chốt ngay hiệu ứng đang chạy — vuốt liên tiếp thật nhanh thì cử chỉ sau vẫn được khoá hướng.
    function swChot() { if (!swHang) return; var h = swHang; swHang = null; clearTimeout(h.t); h.fn(); }
    function swBack(s) {
      var cur = slides[current], nb = s.nb;
      swPos(cur, 0, true);
      if (nb) swPos(nb, s.dx < 0 ? s.w : -s.w, true);
      swSau(function() { swClear(cur); if (nb) swClear(nb); });
    }
    gl.addEventListener('touchstart', function(e) {
      swChot();
      sw = e.touches.length > 1 ? null
        : { x: e.touches[0].clientX, y: e.touches[0].clientY, t: Date.now(), w: gl.offsetWidth, dir: null, dx: 0, nb: null };
    }, { passive: true });
    gl.addEventListener('touchmove', function(e) {
      if (!sw) return;
      if (e.touches.length > 1) { if (sw.dir === 'x') swBack(sw); sw = null; return; }
      var dx = e.touches[0].clientX - sw.x, dy = e.touches[0].clientY - sw.y;
      if (!sw.dir) {
        if (dx * dx + dy * dy < 25) return;
        sw.dir = Math.abs(dx) * 1.2 > Math.abs(dy) ? 'x' : 'y';
      }
      if (sw.dir !== 'x') return;
      if (e.cancelable) e.preventDefault();
      var nb = slides[current + (dx < 0 ? 1 : -1)] || null;
      if (sw.nb && sw.nb !== nb) swClear(sw.nb);
      sw.nb = nb;
      if (!nb) dx = dx / 3;   // ảnh đầu/cuối: kéo nặng tay rồi bật lại
      sw.dx = dx;
      swPos(slides[current], dx);
      if (nb) { nb.style.opacity = '1'; nb.style.zIndex = '1'; swPos(nb, dx + (dx < 0 ? sw.w : -sw.w)); }
    }, { passive: false });
    function swEnd() {
      var s = sw; sw = null;
      if (!s || s.dir !== 'x') return;
      var cur = slides[current], nb = s.nb;
      var flick = Math.abs(s.dx) > 30 && Date.now() - s.t < 300;
      if (!nb || (Math.abs(s.dx) < s.w * 0.2 && !flick)) { swBack(s); return; }
      swPos(cur, s.dx < 0 ? -s.w : s.w, true);
      swPos(nb, 0, true);
      swSau(function() {
        // ảnh cũ tắt ngay (ép tính style trước khi gỡ class) — không mờ dần chồng lên ảnh mới
        cur.style.transition = 'none'; cur.style.opacity = '0'; void cur.offsetWidth;
        goTo(slides.indexOf(nb));
        swClear(nb); swClear(cur);
      });
    }
    gl.addEventListener('touchend', swEnd, { passive: true });
    gl.addEventListener('touchcancel', swEnd, { passive: true });

    // ── Variant thumbnails — 1 thumbnail/màu (dedup by options[0]) ──
    var vtStrip = null;
    if (variantData.length > 1) {
      // Dedup: chỉ lấy entry đầu tiên cho mỗi giá trị options[0]
      var seenOpt0 = {};
      var dedupedVariants = variantData.filter(function(v) {
        var key = (v.options && v.options[0]) || v.mediaId;
        if (seenOpt0[key]) return false;
        seenOpt0[key] = true;
        return true;
      });

      if (dedupedVariants.length > 1) {
        vtStrip = document.createElement('div');
        vtStrip.className = 'njoy-vt';
        vtStrip.id = 'NjoyVT-' + NJOY_SID + '';
        vtStrip.style.pointerEvents = 'none';   // bộ chọn phân loại chưa dựng: bấm lúc này sẽ lệch màu với giỏ

        // Xác định option0 đang được chọn
        var activeOpt0 = null;
        variantData.forEach(function(v) { if (v.selected) activeOpt0 = v.options && v.options[0]; });

        dedupedVariants.forEach(function(v) {
          var opt0 = (v.options && v.options[0]) || '';
          var btn = document.createElement('button');
          btn.className = 'njoy-vt-btn' + (opt0 === activeOpt0 ? ' is-active' : '');
          btn.dataset.vtMedia   = v.mediaId;
          btn.dataset.vtOption0 = opt0;
          var img = document.createElement('img');
          img.src = v.img; img.alt = opt0; img.loading = 'lazy';
          btn.appendChild(img);
          vtStrip.appendChild(btn);
        });

        // Insert sau gallery — dots giờ overlay đè ẢNH (nằm lồng bên trong gl,
        // không còn là sibling bên ngoài) nên không dùng làm anchor được nữa.
        gl.insertAdjacentElement('afterend', vtStrip);

        vtStrip.addEventListener('click', function(e) {
          var btn = e.target.closest('.njoy-vt-btn');
          if (!btn) return;

          // Chuyển slide sang ảnh của màu này
          var mediaId = btn.dataset.vtMedia;
          var idx = slides.findIndex(function(s) { return s.dataset.mediaId === mediaId; });
          if (idx >= 0) goTo(idx);

          // Cập nhật active thumbnail
          vtStrip.querySelectorAll('.njoy-vt-btn').forEach(function(b) { b.classList.remove('is-active'); });
          btn.classList.add('is-active');

          // Báo cho chip picker biết để nó tự syncUI() đúng cách
          var opt0 = btn.dataset.vtOption0;
          if (opt0) {
            document.dispatchEvent(new CustomEvent('njoy:thumbnail-click', { detail: { opt0: opt0 } }));
          }
        });
      }
    }

    // Lookup slide index bằng options[0] từ variantData
    function slideIdxByOpt0(opt0) {
      var match = variantData.find(function(v) { return v.options && v.options[0] === opt0; });
      if (!match) return -1;
      return slides.findIndex(function(s) { return s.dataset.mediaId === match.mediaId; });
    }

    function syncThumb(opt0) {
      if (!vtStrip || !opt0) return;
      vtStrip.querySelectorAll('.njoy-vt-btn').forEach(function(b) {
        b.classList.toggle('is-active', b.dataset.vtOption0 === opt0);
      });
    }

    // ── Chip click → jump ngay (kể cả khi chip đã active) ──
    document.addEventListener('njoy:color-jump', function(e) {
      var opt0 = e.detail && e.detail.opt0;
      if (!opt0) return;
      var idx = slideIdxByOpt0(opt0);
      if (idx >= 0) goTo(idx);
      syncThumb(opt0);
    });

    // ── Sync khi Dawn đổi variant (từ select/URL, không phải từ chip click trực tiếp) ──
    document.addEventListener('product:variant:change', function(e) {
      var variant = e.detail && e.detail.variant;
      if (!variant) return;

      var opt0 = variant.options && variant.options[0];
      var fmId = variant.featured_media && variant.featured_media.id;

      // Ưu tiên featured_media; fallback sang variantData lookup nếu null
      if (fmId) {
        var activeMediaId = '' + NJOY_SID + '-' + fmId;
        var fmIdx = slides.findIndex(function(s) { return s.dataset.mediaId === activeMediaId; });
        if (fmIdx >= 0) goTo(fmIdx);
      } else if (opt0) {
        var fallbackIdx = slideIdxByOpt0(opt0);
        if (fallbackIdx >= 0) goTo(fallbackIdx);
      }

      syncThumb(opt0);
    });

    // ── Wrap gallery + thumbnail strip trong .njoy-gl-wrap ──
    var glWrap = document.createElement('div');
    glWrap.className = 'njoy-gl-wrap';
    gl.parentNode.insertBefore(glWrap, gl);
    glWrap.appendChild(thumbsEl);
    glWrap.appendChild(gl);
  }

  function njoyMoveShippingText() {
    var taxEl = document.querySelector('.section-' + NJOY_SID + '-padding .product__tax');
    var buttonsEl = document.querySelector('.section-' + NJOY_SID + '-padding .product-form__buttons');
    if (!taxEl || !buttonsEl) return;
    buttonsEl.insertAdjacentElement('afterend', taxEl);
  }

  // ── Trust line: gộp 3 mục (chính hãng/giao hoả tốc/đổi trả) vào 1 dòng, ngăn
  // cách bằng "|" — mỗi mục có bản chữ đầy đủ (desktop) + rút gọn (mobile), CSS
  // tự chọn hiện bản nào theo viewport. Chèn ngay trên shipping text.
  function njoyBuildTrustLines() {
    var taxEl = document.querySelector('.section-' + NJOY_SID + '-padding .product__tax');
    if (!taxEl || document.getElementById('njoy-trust-line-' + NJOY_SID + '')) return;
    var items = [
      ['genuine', 'Sản phẩm chính hãng', 'Chính hãng'],
      ['fast', 'Ship nhanh hoả tốc', 'Ship hoả tốc'],
      ['return', 'Hỗ trợ đổi trả trong 30 ngày', 'Đổi trả 30 ngày']
    ];
    var p = document.createElement('p');
    p.id = 'njoy-trust-line-' + NJOY_SID + '';
    p.className = 'njoy-trust-line';
    p.innerHTML = items.map(function (it, i) {
      return (i > 0 ? '<span class="njoy-trust-line__sep">•</span>' : '') +
        '<span class="njoy-trust-line__item njoy-trust-line__item--' + it[0] + '">' +
          '<span class="njoy-trust-line__long">' + it[1] + '</span>' +
          '<span class="njoy-trust-line__short">' + it[2] + '</span>' +
        '</span>';
    }).join('');
    taxEl.insertAdjacentElement('beforebegin', p);
  }

  // ── Dời section "Nên mua cùng với" (njoy-recs-comp, section riêng) xuống dưới nút ATC
  // + dòng cam kết (Nick 03/11: bấm sticky thấy gọn phân loại + nút) — nằm trong .product.grid
  // nên tự động theo grid khi njoyDesktopLayout() chuyển grid vào cột phải ──
  function njoyMoveRecsBelowATC() {
    var recsEl = document.getElementById('shopify-section-' + NJOY_SID.replace('__main', '') + '__njoy-recs-comp');
    var buttonsEl = document.querySelector('.section-' + NJOY_SID + '-padding .product-form__buttons');
    if (!recsEl || !buttonsEl || recsEl.dataset.njoyMoved) return;
    recsEl.dataset.njoyMoved = '1';
    /* Nick 04/11: Nên mua cùng ngay dưới phân loại, Chính hãng + địa chỉ xuống dưới nó */
    buttonsEl.insertAdjacentElement('afterend', recsEl);
  }

  // ── "Dòng máy": sắp xếp đời máy mới nhất trước (parse số ngay trong tên,
  // "iPhone 17 Pro Max" → 17), rồi truncate 2 dòng + nút "Xem thêm" nếu tràn. ──
  function njoySortModelList() {
    var valueEl = document.getElementById('njoy-feat-model-' + NJOY_SID + '');
    if (!valueEl || valueEl.dataset.njoySorted) return;
    valueEl.dataset.njoySorted = '1';

    // Lấy SỐ LỚN NHẤT trong tên (không chỉ số đầu tiên) — bug cũ dùng match() chỉ lấy
    // số đầu, nên tên ghép kiểu "iPhone 13/14" bị xếp theo 13 thay vì 14 (đời mới nhất
    // thật sự). Tên không có số nào (dòng "X" — X/Xs/Xsmax/Xr, không dùng số) trước đây
    // luôn rơi về 0 → luôn xếp cuối bảng bất kể đời thật; nay gán rank 10 (Apple gọi
    // "iPhone 10") để xếp đúng vị trí thời gian giữa đời 8 và đời 11.
    function njoyModelRank(text) {
      var nums = text.match(/\d+/g);
      if (nums && nums.length) {
        return Math.max.apply(null, nums.map(function (n) { return parseInt(n, 10); }));
      }
      if (/x/i.test(text)) return 10;
      return 0;
    }
    // Cùng đời số (VD "17") → bản cao cấp hơn đứng trước: Pro Max > Pro > Plus/Air > bản thường.
    function njoySuffixRank(text) {
      var t = text.toLowerCase();
      if (t.indexOf('pro max') !== -1) return 3;
      if (t.indexOf('pro') !== -1) return 2;
      if (t.indexOf('plus') !== -1 || t.indexOf('air') !== -1) return 1;
      return 0;
    }

    var items = valueEl.textContent.split(',').map(function (s) { return s.trim(); }).filter(Boolean);
    items.sort(function (a, b) {
      var diff = njoyModelRank(b) - njoyModelRank(a);
      if (diff !== 0) return diff;
      return njoySuffixRank(b) - njoySuffixRank(a);
    });
    valueEl.textContent = items.join(', ');

    var moreBtn = document.getElementById('njoy-feat-model-more-' + NJOY_SID + '');
    if (!moreBtn) return;
    requestAnimationFrame(function () {
      if (valueEl.scrollHeight > valueEl.clientHeight + 1) {
        moreBtn.hidden = false;
        moreBtn.addEventListener('click', function () {
          var expanded = valueEl.classList.toggle('is-expanded');
          moreBtn.textContent = expanded ? 'Thu gọn' : 'Xem thêm';
        });
      }
    });
  }

  // ── Dời section "Tính Năng" (render sẵn ở đâu đó trong info-container).
  // Mobile: ngay dưới location-bar (info-container giữ nguyên section, mô tả
  // sản phẩm là section riêng theo SAU). Desktop: xuống cột trái, dưới gallery
  // (njoyDesktopLayout() đã chạy trước nên .njoy-2col__left chắc chắn tồn tại;
  // njoyMovePdesc/njoyMoveReviews đăng ký SAU nên sẽ tự nối tiếp phía sau). ──
  // Điện thoại: Thông tin nổi bật chỉ hiện 3 dòng đầu, còn lại sau nút Xem thêm (Nick 04/11). Chạy sau njoySortModelList vì nó cần đo dòng đang hiện.
  function njoyRutThongTin() {
    var featEl = document.getElementById('njoy-feat-section-' + NJOY_SID + '');
    if (!featEl || window.innerWidth >= 750 || featEl.querySelector('.njoy-feat-them')) return;
    var cells = featEl.querySelectorAll('.njoy-feat-cell');
    if (cells.length <= 3) return;
    for (var i = 3; i < cells.length; i++) cells[i].classList.add('njoy-an-gon');
    var hop = document.createElement('div');
    hop.className = 'njoy-feat-them';
    hop.innerHTML = '<button type="button" class="njoy-cong" aria-expanded="false" aria-label="Xem thêm"></button>';
    var nut = hop.firstChild, grid = featEl.querySelector('.njoy-feat-grid');
    var dat = function (an) { for (var k = 3; k < cells.length; k++) cells[k].classList.toggle('njoy-an-gon', an); };
    nut.addEventListener('click', function () {
      // Nick 04/11: mở, thu có hiệu ứng trượt; nút + xoay thành ×
      var mo = nut.getAttribute('aria-expanded') !== 'true', h0 = grid.offsetHeight, xong = false;
      nut.setAttribute('aria-expanded', String(mo));
      nut.setAttribute('aria-label', mo ? 'Thu gọn' : 'Xem thêm');
      if (mo) dat(false);
      var h1;
      if (mo) { h1 = grid.scrollHeight; } else { dat(true); h1 = grid.scrollHeight; dat(false); }
      grid.style.overflow = 'hidden';
      grid.style.height = h0 + 'px';
      grid.offsetHeight;
      grid.style.transition = 'height .42s cubic-bezier(.22, .7, .3, 1)';
      grid.style.height = h1 + 'px';
      var ket = function () {
        if (xong) return;
        xong = true;
        if (!mo) dat(true);
        grid.style.overflow = grid.style.height = grid.style.transition = '';
      };
      grid.addEventListener('transitionend', ket, { once: true });
      setTimeout(ket, 500);
    });
    featEl.appendChild(hop);
  }

  // Tên màu đang chọn hiện cạnh nhãn, không nằm trong nút để các chấm không xê dịch (Nick 04/11)
  function njoyTenMau() {
    document.querySelectorAll('.njoy-vp__group').forEach(function (g) {
      var chon = g.querySelector('.njoy-vp__chip--swatch.is-active'), nhan = g.querySelector('.njoy-vp__label');
      if (!nhan || !g.querySelector('.njoy-vp__chip--swatch')) return;
      var ten = nhan.querySelector('.njoy-vp__ten-mau'), val = chon ? chon.dataset.val : '';
      if (ten && ten.textContent === val) return;
      if (ten) ten.remove();
      if (!val) return;
      ten = document.createElement('span');
      ten.className = 'njoy-vp__ten-mau';
      ten.textContent = val;
      nhan.appendChild(ten);
    });
  }
  document.addEventListener('njoy:vp-sync', njoyTenMau);

  function njoyMoveFeatSection() {
    var featEl = document.getElementById('njoy-feat-section-' + NJOY_SID + '');
    if (!featEl || featEl.dataset.njoyMoved) return;

    if (window.innerWidth >= 750) {
      var leftCol = document.querySelector('.njoy-2col__left');
      if (!leftCol) return;
      featEl.dataset.njoyMoved = '1';
      leftCol.appendChild(featEl);
      return;
    }

    var locationBar = document.getElementById('njoy-trust-line-' + NJOY_SID + '');
    if (!locationBar) return;
    featEl.dataset.njoyMoved = '1';
    locationBar.insertAdjacentElement('afterend', featEl);
  }

  function njoyBuildVariantPicker() {

    var optData;
    try {
      optData = JSON.parse(document.getElementById('NjoyOptionData-' + NJOY_SID + '').textContent);
    } catch(e) { return; }
    if (!optData || !optData.options || !optData.options.length) return;
    if (optData.options.length === 1 && optData.options[0] === 'Title') return;

    var options  = optData.options;
    var variants = optData.variants;
    var selected = optData.selected.slice();

    var swatchMap = {};
    (optData.swatches || []).forEach(function(sw) {
      if (!swatchMap[sw.o]) swatchMap[sw.o] = {};
      swatchMap[sw.o][sw.v] = sw;
    });

    var vp = document.createElement('div');
    vp.className = 'njoy-vp';
    vp.id = 'NjoyVP-' + NJOY_SID + '';

    // Bỏ "Gợi ý theo máy bạn" (đoán đời theo cỡ màn hình) — Nick 29/10
    var MORE_LIMIT = Infinity;   // Nick 04/11: hiện đủ đời máy, không gom "+N đời khác"

    var groups = options.map(function(optName, optIdx) {
      var values = [];
      variants.forEach(function(v) {
        var val = v.options[optIdx];
        if (val && values.indexOf(val) === -1) values.push(val);
      });

      var group = document.createElement('div');
      group.className = 'njoy-vp__group';

      // Phần đầu chung của mọi giá trị ("iPhone " ở Dòng máy, "Ripple ST360-" ở Màu) chỉ hiện 1 lần cạnh nhãn,
      // nút chỉ còn phần khác nhau → ngắn, ít hàng hơn. data-val vẫn là giá trị đầy đủ (Nick 28/10).
      var isModel = values.length > 0 && values.every(function(v) { return /^iphone\s*\d+/i.test(v); });
      var common = '';
      if (values.length >= 2 && !isModel) {   // đời iPhone giữ nguyên chữ "iPhone" trên nút (Nick 29/10)
        common = values.reduce(function(p, v) { var i = 0; while (i < p.length && i < v.length && p[i] === v[i]) i++; return p.slice(0, i); });
        var cut = Math.max(common.lastIndexOf(' '), common.lastIndexOf('-'));
        common = cut > 0 ? common.slice(0, cut + 1) : '';
        // Không cắt khi phần còn lại rỗng hoặc mở đầu bằng 1 ký tự lẻ ("C to C 100W"/"C to L 20W" → "C 100W" khó hiểu)
        if (common && values.some(function(v) { var r = v.slice(common.length).replace(/^[\s-]+/, ''); return !r || /^\S([\s-]|$)/.test(r); })) common = '';
      }
      function shortVal(v) { return common ? v.slice(common.length).replace(/^[\s-]+/, '') : v; }

      var label = document.createElement('span');
      label.className = 'njoy-vp__label';
      // Viết hoa chữ đầu như "Đánh giá sản phẩm": "Sản Phẩm - Màu" → "Sản phẩm - màu"; giữ từ kiểu "iPhone"/"USB" (Nick 29/10)
      label.textContent = optName.split(' ').map(function(w, i) { return i && /^\p{Lu}\p{Ll}+(-\p{Lu}\p{Ll}+)?$/u.test(w) ? w.toLocaleLowerCase('vi') : w; }).join(' ');
      if (common) {
        var hint = document.createElement('span');
        hint.className = 'njoy-vp__hint';
        hint.textContent = common.replace(/[\s-]+$/, '');
        label.appendChild(hint);
      }
      group.appendChild(label);

      var chipsEl = document.createElement('div');
      chipsEl.className = 'njoy-vp__chips';
      // Dòng iPhone: đời mới trước (18 → 14), trong cùng đời: thường → Plus/Air → Pro → Pro Max
      if (values.every(function(v) { return /^iphone\s*\d+/i.test(v); })) {
        var rank = function(s) { s = s.toLowerCase(); return /pro max/.test(s) ? 3 : /pro/.test(s) ? 2 : /plus|air/.test(s) ? 1 : 0; };
        var gen = function(s) { return parseInt(s.replace(/^iphone\s*/i, ''), 10); };
        values.sort(function(a, b) { return gen(b) - gen(a) || rank(a) - rank(b) || a.localeCompare(b); });
      } else {
        values.sort(function(a, b) { return a.localeCompare(b); });
      }
      var anySwatch = false;
      values.forEach(function(val) {
        var btn = document.createElement('button');
        btn.type = 'button';
        var sw = swatchMap[optIdx] && swatchMap[optIdx][val];
        var hasSwatch = !!(sw && (sw.color || sw.image));
        if (hasSwatch) anySwatch = true;
        if (hasSwatch) { btn.title = val; btn.setAttribute('aria-label', val); }   // Nick 04/11: chỉ hiện chấm màu, tên để trình đọc màn hình và tooltip
        else if (shortVal(val) !== val) btn.title = val;
        btn.className = 'njoy-vp__chip' + (hasSwatch ? ' njoy-vp__chip--swatch' : '') + (val === selected[optIdx] ? ' is-active' : '');
        btn.dataset.optIdx = optIdx;
        btn.dataset.val = val;
        if (hasSwatch) {
          var swatchEl = document.createElement('span');
          swatchEl.className = 'njoy-vp__swatch';
          if (sw.image) swatchEl.style.backgroundImage = 'url(' + sw.image + ')';
          else swatchEl.style.background = sw.color;
          btn.appendChild(swatchEl);
          var textEl = document.createElement('span');
          textEl.textContent = shortVal(val);
          btn.appendChild(textEl);
        } else if (isModel) {
          var pre = document.createElement('span');
          pre.className = 'njoy-vp__pre';
          pre.textContent = 'iPhone';
          btn.appendChild(pre);
          btn.appendChild(document.createTextNode(' ' + val.replace(/^iphone\s*/i, '')));
        } else {
          btn.textContent = shortVal(val);
        }
        chipsEl.appendChild(btn);
      });
      // Nhiều nút chữ (≥6, vd Dòng máy) → lưới cột đều thay vì so le nhiều độ dài
      if (!anySwatch && values.length >= 6) chipsEl.classList.add('njoy-vp__chips--grid');
      if (isModel) chipsEl.classList.add('njoy-vp__chips--model');
      if (isModel && values.length > MORE_LIMIT + 1) {
        var more = document.createElement('button');
        more.type = 'button';
        more.className = 'njoy-vp__more';
        chipsEl.appendChild(more);
      }

      group.appendChild(chipsEl);
      vp.appendChild(group);
      return group;
    });

    // Nick 04/11: tên nhóm đồng nhất, màu trên cùng, dòng máy dưới cùng. Chỉ đổi thứ tự hiển thị, data-opt-idx và dữ liệu giữ nguyên.
    if (window._njoyNhom) {
      var nhomSP = groups.map(function(g, i) {
        var vals = [].map.call(g.querySelectorAll('.njoy-vp__chip'), function(c) { return c.dataset.val; });
        var nh = window._njoyNhom(options[i], vals, !!g.querySelector('.njoy-vp__chip--swatch'));
        var lb = g.querySelector('.njoy-vp__label');
        if (lb && lb.firstChild && lb.firstChild.nodeType === 3) lb.firstChild.nodeValue = nh.ten;
        return nh;
      });
      groups.map(function(g, i) { return i; })
        .sort(function(a, b) { return nhomSP[a].hang - nhomSP[b].hang || a - b; })
        .forEach(function(i) { vp.appendChild(groups[i]); });
    }

    // Anchor: NjoyVT > gl-wrap > gl. gl đã nằm trong wrap → chèn sau gl thì vp lọt vào trong wrap (bug SP 1 phân loại).
    var insertAfter = document.getElementById('NjoyVT-' + NJOY_SID + '')
                   || document.querySelector('.section-' + NJOY_SID + '-padding .njoy-gl-wrap')
                   || document.getElementById('NjoyGL-' + NJOY_SID + '');
    if (!insertAfter) return;
    insertAfter.insertAdjacentElement('afterend', vp);

    var mainProduct = document.getElementById('MainProduct-' + NJOY_SID + '');
    if (mainProduct) mainProduct.classList.add('njoy-vp-active');

    function updateAvailability() {
      options.forEach(function(_, optIdx) {
        groups[optIdx].querySelectorAll('.njoy-vp__chip').forEach(function(chip) {
          // Nick 04/11: hiện đủ đời máy dù hết sạch (mờ, bấm được để Nhắc shop); chỉ ẩn giá trị không có biến thể nào
          var coBien = variants.some(function(v) { return v.options[optIdx] === chip.dataset.val; });
          chip.classList.toggle('is-unavailable', !coBien);
        });
      });
      if (window.njoyVpOut) njoyVpOut(variants, selected);
      applyMore();
    }

    function applyMore() {
      groups.forEach(function(group) {
        var more = group.querySelector('.njoy-vp__more');
        if (!more) return;
        var avail = [].filter.call(group.querySelectorAll('.njoy-vp__chip'), function(c) { return !c.classList.contains('is-unavailable'); });
        var open = group.classList.contains('is-expanded');
        var thu = avail.length > MORE_LIMIT + 1;
        var an = 0;
        avail.forEach(function(c, i) {
          var hide = thu && !open && i >= MORE_LIMIT && !c.classList.contains('is-active');
          c.classList.toggle('is-more-hidden', hide);
          if (hide) an++;
        });
        more.classList.toggle('is-off', !thu);
        more.textContent = open ? 'Thu gọn' : '+' + an + ' đời khác';
      });
    }

    function syncUI(skipDispatch) {
      options.forEach(function(_, optIdx) {
        var sel = selected[optIdx] || '';
        groups[optIdx].querySelectorAll('.njoy-vp__chip').forEach(function(chip) {
          chip.classList.toggle('is-active', chip.dataset.val === sel);
        });
      });
      updateAvailability();

      // Tìm variant khớp từ dữ liệu local
      var matchedVariant = variants.find(function(v) {
        return v.options.every(function(opt, i) { return opt === selected[i]; });
      });

      if (matchedVariant) {
        // Cập nhật hidden input [name="id"] ngay — không chờ Dawn fetch
        var idInput = document.querySelector('#product-form-' + NJOY_SID + ' input[name="id"]');
        if (idInput) idInput.value = matchedVariant.id;

        // Cập nhật trạng thái nút ATC sau khi Dawn resetProductFormState chạy xong
        setTimeout(function() {
          var btn = document.querySelector('.section-' + NJOY_SID + '-padding [name="add"]');
          if (!btn || btn.classList.contains('loading')) return;
          var sp = btn.querySelector('span');
          if (matchedVariant.available) {
            btn.removeAttribute('disabled');
            btn.removeAttribute('aria-disabled');
            if (sp) sp.textContent = (window.variantStrings && window.variantStrings.addToCart) || 'Thêm vào giỏ hàng';
          } else {
            btn.setAttribute('disabled', 'disabled');
            if (sp) sp.textContent = (window.variantStrings && window.variantStrings.soldOut) || 'Hết hàng';
          }
        }, 0);
      }

      // Tổ hợp hết hàng: KHÔNG nhờ Dawn tải lại — server trả phân loại còn hàng, form đổi về đời khác → khách mua nhầm (02/11)
      if (!skipDispatch && matchedVariant && matchedVariant.available) {
        var variantEl = document.getElementById('variant-selects-' + NJOY_SID + '');
        if (!variantEl) return;
        var selects = variantEl.querySelectorAll('select.select__select');
        if (selects.length) {
          // Dawn (global.js selectedOptionValues) đọc THUỘC TÍNH option[selected], không đọc sel.value → phải gắn thuộc tính,
          // không thì đổi nhóm không phải nhóm cuối (vd Màu) Dawn vẫn tải biến thể CŨ và form thêm nhầm màu vào giỏ (29/10)
          selects.forEach(function(sel, i) {
            if (selected[i] == null) return;
            sel.value = selected[i];
            [].forEach.call(sel.options, function(o) {
              if (o.value === selected[i]) o.setAttribute('selected', 'selected'); else o.removeAttribute('selected');
            });
          });
          selects[selects.length - 1].dispatchEvent(new Event('change', { bubbles: true }));
        } else {
          variantEl.querySelectorAll('fieldset').forEach(function(fs, i) {
            var inp = fs.querySelector('input[value="' + (selected[i] || '').replace(/"/g, '\\"') + '"]');
            if (inp && !inp.checked) { inp.checked = true; inp.dispatchEvent(new Event('change', { bubbles: true })); }
          });
        }
      }
    }

    vp.addEventListener('click', function(e) {
      var moreBtn = e.target.closest('.njoy-vp__more');
      if (moreBtn) {
        moreBtn.closest('.njoy-vp__group').classList.toggle('is-expanded');
        applyMore();
        return;
      }
      var chip = e.target.closest('.njoy-vp__chip');
      if (!chip || chip.classList.contains('is-unavailable')) return;
      var optIdx = parseInt(chip.dataset.optIdx, 10);
      var val = chip.dataset.val;
      // Luôn dispatch gallery jump kể cả khi chip đã active
      if (optIdx === 0) {
        document.dispatchEvent(new CustomEvent('njoy:color-jump', { detail: { opt0: val } }));
      }
      if (window.njoyMay) njoyMay.luu(val);
      if (selected[optIdx] === val) return;
      selected[optIdx] = val;
      syncUI();
    });

    document.addEventListener('product:variant:change', function(e) {
      var variant = e.detail && e.detail.variant;
      if (!variant || !variant.options) return;
      variant.options.forEach(function(val, i) { selected[i] = val; });
      syncUI(true);
    });

    // Thumbnail click → chip picker nhận opt0 và tự sync đầy đủ (dispatch + Dawn update)
    document.addEventListener('njoy:thumbnail-click', function(e) {
      var newOpt0 = e.detail && e.detail.opt0;
      if (!newOpt0 || selected[0] === newOpt0) return;
      selected[0] = newOpt0;
      syncUI();
    });

    updateAvailability();

    // Nếu variant đang chọn hết hàng → tự chuyển sang variant có hàng đầu tiên
    var currentAvail = variants.some(function(v) {
      return v.available && v.options.every(function(opt, i) { return opt === selected[i]; });
    });
    if (!currentAvail) {
      var firstAvail = variants.find(function(v) { return v.available; });
      if (firstAvail) {
        firstAvail.options.forEach(function(opt, i) { selected[i] = opt; });
        syncUI();
      }
    }

    // Nhớ đời máy khách đã chọn (Nick 03/11). Link có ?variant= (quảng cáo, chia sẻ) giữ nguyên phân loại của link
    if (window.njoyMay && !/[?&]variant=/.test(location.search)) {
      var vMay = njoyMay.tim(options, variants, selected);
      if (vMay) {
        var doiMau = vMay.options[0] !== selected[0];
        vMay.options.forEach(function(opt, i) { selected[i] = opt; });
        syncUI();
        if (doiMau) document.dispatchEvent(new CustomEvent('njoy:color-jump', { detail: { opt0: selected[0] } }));
      }
    }
  }

  // ── Mobile only: đưa giá+tiêu đề (.njoy-info-preview) xuống DƯỚI ảnh + hàng ảnh phân loại (.njoy-vt),
  //    ngay trên bộ chọn phân loại (.njoy-vp) — Nick đổi 28/10/2026 (trước đó nằm TRÊN ảnh). Tên hàm giữ nguyên. ──
  function njoyMoveInfoAboveGallery() {
    if (window.innerWidth >= 750) return;
    var pageWidth = document.querySelector('.section-' + NJOY_SID + '-padding .page-width');
    if (!pageWidth) return;
    var preview = pageWidth.querySelector('.njoy-info-preview');
    var glWrap = pageWidth.querySelector('.njoy-gl-wrap');
    if (!preview || !glWrap) return;
    var anchor = pageWidth.querySelector(':scope > .njoy-vt') || glWrap;
    anchor.parentNode.insertBefore(preview, anchor.nextSibling);
  }

  function njoyTruncateTitles() {
    document.querySelectorAll('.related-products .card__heading a, .featured-collection .card__heading a').forEach(function (el) {
      var text = el.getAttribute('data-njoy-full') || el.textContent.trim();
      if (!el.getAttribute('data-njoy-full')) el.setAttribute('data-njoy-full', text);
      el.textContent = text.length > 50 ? text.slice(0, 50).trimEnd() + '…' : text;
    });
    var rp = document.querySelector('related-products');
    if (rp && !rp._njoyObs) {
      rp._njoyObs = new MutationObserver(njoyTruncateTitles);
      rp._njoyObs.observe(rp, { childList: true, subtree: true });
    }
  }

  function njoyDesktopLayout() {
    if (window.innerWidth < 750) return;

    var pageWidth = document.querySelector('.section-' + NJOY_SID + '-padding .page-width');
    if (!pageWidth) return;

    // Move VP chips vào đầu info-container
    var vp = document.getElementById('NjoyVP-' + NJOY_SID + '');
    var infoContainer = pageWidth.querySelector('.product__info-container');
    if (vp && infoContainer && !infoContainer.contains(vp)) {
      infoContainer.insertBefore(vp, infoContainer.firstChild);
    }

    // Build 2-col layout (skip nếu đã build)
    if (pageWidth.querySelector('.njoy-2col')) return;

    var glWrap    = pageWidth.querySelector('.njoy-gl-wrap');
    var vtEl      = document.getElementById('NjoyVT-' + NJOY_SID + '');
    var previewEl = pageWidth.querySelector('.njoy-info-preview');
    var grid      = pageWidth.querySelector('.product.grid');

    if (!glWrap || !grid) return;

    var col2     = document.createElement('div');
    col2.className = 'njoy-2col';

    var leftCol  = document.createElement('div');
    leftCol.className = 'njoy-2col__left';

    var rightCol = document.createElement('div');
    rightCol.className = 'njoy-2col__right';

    // Left: gallery wrap (dots nằm sẵn bên trong gl, tự theo — ẩn bằng CSS
    // trên desktop) + vt strip (ẩn bằng CSS)
    leftCol.appendChild(glWrap);
    if (vtEl) leftCol.appendChild(vtEl);

    // Right: title/type/price + product grid (VP, ATC, shipping, ...)
    if (previewEl) rightCol.appendChild(previewEl);
    rightCol.appendChild(grid);

    col2.appendChild(leftCol);
    col2.appendChild(rightCol);
    pageWidth.insertBefore(col2, pageWidth.firstChild);

    // Trigger resize để gallery height tính lại sau khi vào 2-col
    window.dispatchEvent(new Event('resize'));

    njoySyncRightColTop();
  }

  // ── Sync khoảng cách sticky của cột phải theo ĐÚNG chiều cao header sticky thật
  // (header dùng sticky_header_type "always", z-index cao hơn nội dung page) — nếu
  // chỉ để top:20px cố định, tiêu đề SP (nằm ngay đầu cột phải) sẽ bị header đè lên,
  // ẩn mất mỗi khi cột phải bắt đầu dính (bug thật, phát hiện qua ảnh Nick gửi).
  // ResizeObserver để tự đồng bộ lại nếu header đổi chiều cao (bật/tắt announcement
  // bar, responsive nav...). ──
  function njoySyncRightColTop() {
    // .shopify-section-group-header-group dùng CHUNG cho mọi section trong nhóm header
    // (kể cả announcement bar, KHÔNG sticky) — querySelector sẽ vớ nhầm section đầu tiên
    // trong nhóm nếu dùng class đó. .section-header mới là class riêng của đúng section
    // header sticky thật (đã verify qua DevTools: position:sticky, top:0, z-index:3).
    var header = document.querySelector('.section-header');
    var rightCol = document.querySelector('.njoy-2col__right');
    if (!header || !rightCol) return;

    function sync() {
      if (window.innerWidth < 750) return;
      var h = header.getBoundingClientRect().height;
      if (h <= 0) return;
      rightCol.style.top = (h + 20) + 'px';
    }

    sync();
    if (window.ResizeObserver) {
      new ResizeObserver(sync).observe(header);
    } else {
      window.addEventListener('resize', sync);
    }
  }

  // ── FIX 2: Sync thumbnail strip height = gallery image height ──
  function njoySetupThumbSync() {
    if (window.innerWidth < 750) return;
    var gl    = document.getElementById('NjoyGL-' + NJOY_SID + '');
    var thumbs = document.querySelector('.section-' + NJOY_SID + '-padding .njoy-gl__thumbs');
    if (!gl || !thumbs) return;

    function sync() {
      var h = gl.getBoundingClientRect().height;
      if (h <= 0) return;
      // Peek: hiển thị thêm nửa thumb để gợi ý scroll (thumbSize:60 + gap:8 = 68)
      var unit = 68;
      thumbs.style.maxHeight = (Math.floor(h / unit) * unit + unit / 2) + 'px';
    }

    sync();
    window.addEventListener('resize', sync);
    if (window.ResizeObserver) {
      new ResizeObserver(sync).observe(gl);
    }
  }

  // ── Arrow navigation (tablet/desktop only) ──
  function initNjoyArrows() {
    if (window.innerWidth < 750) return;

    var gl = document.getElementById('NjoyGL-' + NJOY_SID + '');
    if (!gl) return;

    var prevBtn = document.createElement('button');
    prevBtn.type = 'button';
    prevBtn.className = 'njoy-gl__arrow njoy-gl__arrow--prev';
    prevBtn.setAttribute('aria-label', 'Previous image');
    prevBtn.innerHTML = '<svg viewBox="0 0 24 24"><polyline points="15 18 9 12 15 6"></polyline></svg>';

    var nextBtn = document.createElement('button');
    nextBtn.type = 'button';
    nextBtn.className = 'njoy-gl__arrow njoy-gl__arrow--next';
    nextBtn.setAttribute('aria-label', 'Next image');
    nextBtn.innerHTML = '<svg viewBox="0 0 24 24"><polyline points="9 18 15 12 9 6"></polyline></svg>';

    gl.appendChild(prevBtn);
    gl.appendChild(nextBtn);

    function getActiveIdx() {
      var active = gl.querySelector('.njoy-gl__thumb.is-active, .njoy-gl__thumbs .njoy-gl__thumb.is-active');
      // Fallback: check active slide
      if (!active) {
        var activeSlide = gl.querySelector('.njoy-gl__slide.is-active');
        var slides = gl.querySelectorAll('.njoy-gl__slide');
        if (activeSlide) return Array.prototype.indexOf.call(slides, activeSlide);
        return 0;
      }
      return parseInt(active.dataset.idx) || 0;
    }

    function getTotalSlides() {
      return gl.querySelectorAll('.njoy-gl__slide').length;
    }

    function updateArrows() {
      var idx = getActiveIdx();
      prevBtn.classList.toggle('is-hidden', idx <= 0);
      nextBtn.classList.toggle('is-hidden', idx >= getTotalSlides() - 1);
    }

    prevBtn.addEventListener('click', function(e) {
      e.stopPropagation();
      var idx = getActiveIdx();
      var prevThumb = document.querySelector('.njoy-gl__thumbs .njoy-gl__thumb[data-idx="' + (idx - 1) + '"]');
      if (prevThumb) { prevThumb.click(); setTimeout(updateArrows, 50); }
    });

    nextBtn.addEventListener('click', function(e) {
      e.stopPropagation();
      var idx = getActiveIdx();
      var nextThumb = document.querySelector('.njoy-gl__thumbs .njoy-gl__thumb[data-idx="' + (idx + 1) + '"]');
      if (nextThumb) { nextThumb.click(); setTimeout(updateArrows, 50); }
    });

    document.querySelectorAll('.njoy-gl__thumbs .njoy-gl__thumb').forEach(function(t) {
      t.addEventListener('click', function() { setTimeout(updateArrows, 50); });
    });

    updateArrows();
  }

  // ── Lightbox: click slide to zoom (desktop) / phát video (mọi kích thước) ──
  function initNjoyLightbox() {
    var isMobile = window.innerWidth < 750;

    var lb = document.createElement('div');
    lb.className = 'njoy-lightbox';
    lb.innerHTML = [
      '<div class="njoy-lightbox__inner" id="njoy-lb-inner-" + NJOY_SID + ""></div>',
      '<button class="njoy-lightbox__close" aria-label="Close">&#x2715;</button>',
      '<button class="njoy-lightbox__nav njoy-lightbox__nav--prev" aria-label="Previous">',
        '<svg viewBox="0 0 24 24"><polyline points="15 18 9 12 15 6"></polyline></svg>',
      '</button>',
      '<button class="njoy-lightbox__nav njoy-lightbox__nav--next" aria-label="Next">',
        '<svg viewBox="0 0 24 24"><polyline points="9 18 15 12 9 6"></polyline></svg>',
      '</button>',
    ].join('');
    document.body.appendChild(lb);

    var lbInner = lb.querySelector('#njoy-lb-inner-' + NJOY_SID + '');
    var lbClose = lb.querySelector('.njoy-lightbox__close');
    var lbPrev  = lb.querySelector('.njoy-lightbox__nav--prev');
    var lbNext  = lb.querySelector('.njoy-lightbox__nav--next');
    var currentIdx = 0;

    function getSlides() {
      return document.querySelectorAll('#NjoyGL-' + NJOY_SID + ' .njoy-gl__slide');
    }

    function openLightbox(idx) {
      currentIdx = idx;
      var slides = getSlides();
      var slide = slides[idx];
      if (!slide) return;

      lbInner.innerHTML = '';

      if (njoyIsVideoSlide(slide)) {
        var vidData = njoyGetVideoData(slide);
        if (vidData) {
          var videoEl = document.createElement('video');
          videoEl.className = 'njoy-lightbox__video';
          videoEl.controls = true; videoEl.autoplay = true;
          videoEl.loop = true; videoEl.playsInline = true;
          if (vidData.poster) videoEl.poster = vidData.poster;
          videoEl.style.maxWidth = '90vw'; videoEl.style.maxHeight = '85vh'; videoEl.style.outline = 'none';
          (vidData.sources || [{ src: vidData.src, type: vidData.type }]).forEach(function(s) {
            var sourceEl = document.createElement('source');
            sourceEl.src = s.src; sourceEl.type = s.type;
            videoEl.appendChild(sourceEl);
          });
          lbInner.appendChild(videoEl);
        } else {
          // Fallback: show poster image if video URL not found in DOM
          var posterImg = slide.querySelector('img');
          if (posterImg) {
            var fbImg = document.createElement('img');
            fbImg.className = 'njoy-lightbox__img';
            fbImg.src = posterImg.src; fbImg.alt = posterImg.alt || '';
            lbInner.appendChild(fbImg);
          }
        }
      } else {
        var img = slide.querySelector('img');
        if (img) {
          var lightboxImg = document.createElement('img');
          lightboxImg.className = 'njoy-lightbox__img';
          lightboxImg.src = img.src || img.dataset.src || '';
          if (img.srcset || img.dataset.srcset) lightboxImg.srcset = img.srcset || img.dataset.srcset;
          lightboxImg.alt = img.alt || '';
          lbInner.appendChild(lightboxImg);
        }
      }

      lbPrev.style.display = idx <= 0 ? 'none' : '';
      lbNext.style.display = idx >= slides.length - 1 ? 'none' : '';
      lb.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }

    function closeLightbox() {
      lb.classList.remove('is-open');
      document.body.style.overflow = '';
      lbInner.innerHTML = '';
    }

    var slides = getSlides();
    slides.forEach(function(slide, idx) {
      // Mobile: ảnh dùng pinch-zoom native, chỉ mở lightbox cho video (để phát video)
      if (isMobile && !njoyIsVideoSlide(slide)) return;
      slide.addEventListener('click', function() { openLightbox(idx); });
    });

    // Sync currentIdx khi active slide thay đổi từ ngoài lightbox
    var gl = document.getElementById('NjoyGL-' + NJOY_SID + '');
    if (gl && window.MutationObserver) {
      new MutationObserver(function() {
        var active = gl.querySelector('.njoy-gl__slide.is-active');
        if (active) currentIdx = Array.prototype.indexOf.call(getSlides(), active);
      }).observe(gl, { subtree: true, attributes: true, attributeFilter: ['class'] });
    }

    lbPrev.addEventListener('click', function(e) {
      e.stopPropagation();
      if (currentIdx > 0) openLightbox(currentIdx - 1);
    });
    lbNext.addEventListener('click', function(e) {
      e.stopPropagation();
      if (currentIdx < getSlides().length - 1) openLightbox(currentIdx + 1);
    });
    lbClose.addEventListener('click', closeLightbox);
    lb.addEventListener('click', function(e) { if (e.target === lb) closeLightbox(); });
    document.addEventListener('keydown', function(e) {
      if (!lb.classList.contains('is-open')) return;
      if (e.key === 'Escape') closeLightbox();
      if (e.key === 'ArrowLeft'  && currentIdx > 0) openLightbox(currentIdx - 1);
      if (e.key === 'ArrowRight' && currentIdx < getSlides().length - 1) openLightbox(currentIdx + 1);
    });
  }

  // Điện thoại: ảnh chính + giá dựng NGAY, không chờ DOMContentLoaded. Sự kiện đó phải đợi mọi script defer của app,
  // đo 03/11: 4G ảnh chính giây thứ 7 mới bắt đầu tải. Bộ chọn phân loại vẫn phải chờ: nó cần variant-selects của global.js.
  var njoyDungSom = window.innerWidth < 750;
  if (njoyDungSom) {
    njoyMoveInfoAbove();
    njoyBuildGallery();
    njoyMoveInfoAboveGallery();
  }
  function njoyKhoiTaoSau() {
    if (!njoyDungSom) {
      njoyMoveInfoAbove();
      njoyBuildGallery();
    }
    njoyBuildVariantPicker();
    var vtMo = document.getElementById('NjoyVT-' + NJOY_SID + '');
    if (vtMo) vtMo.style.pointerEvents = '';
    njoyMoveInfoAboveGallery();
    njoyDesktopLayout();
    njoyMoveShippingText();
    njoyBuildTrustLines();
    njoyMoveFeatSection();
    njoyMoveRecsBelowATC();
    njoySortModelList();
    njoyRutThongTin();
    njoyTruncateTitles();
    njoySetupThumbSync();
    initNjoyArrows();
    initNjoyLightbox();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', njoyKhoiTaoSau);
  else njoyKhoiTaoSau();
})();

// ── Move .njoy-pdesc into right column on tablet+ ──
document.addEventListener('DOMContentLoaded', function njoyMovePdesc() {
  if (window.innerWidth < 750) return;
  var pdesc = document.querySelector('.njoy-pdesc');
  if (!pdesc) return;
  var originalSection = pdesc.closest('section.shopify-section');
  if (originalSection) originalSection.style.display = 'none';
  pdesc.style.display = 'block';
  // Cột trái (dưới gallery/Tính Năng), KHÔNG còn vào cột phải sticky nữa.
  var leftCol = document.querySelector('.njoy-2col__left');
  if (leftCol) {
    leftCol.appendChild(pdesc);
    return;
  }
  var productInfo = document.querySelector('.product__info-container');
  if (!productInfo) return;
  var viewDetails = productInfo.querySelector('.product__view-details');
  if (viewDetails) {
    productInfo.insertBefore(pdesc, viewDetails);
  } else {
    productInfo.appendChild(pdesc);
  }
});

// ── Move #njoy-product-reviews into right column on tablet+, ngay dưới njoy-pdesc
// (đăng ký SAU njoyMovePdesc → DOMContentLoaded listener chạy sau, pdesc đã ở đúng
// chỗ trước khi mình chèn review theo sau nó) ──
document.addEventListener('DOMContentLoaded', function njoyMoveReviews() {
  var reviews = document.getElementById('njoy-product-reviews');
  if (!reviews) return;

  if (window.innerWidth < 750) {
    // Mobile: không có cột sticky — dời Judge.me lên NẰM TRÊN section "Thông tin
    // nổi bật" (featEl, njoyMoveFeatSection() đã chạy trước — đăng ký DOMContentLoaded
    // sớm hơn ở trên — nên featEl chắc chắn đã ở đúng vị trí ngay sau location-bar).
    // Nick chốt: review lên trước, thông số kỹ thuật xuống sau. Fallback về
    // njoy-product-reviews (vị trí cũ) nếu vì lý do gì đó featEl không tồn tại.
    var jdgmMobile = document.getElementById('judgeme_product_reviews');
    if (jdgmMobile) {
      var jdgmSectionMobile = jdgmMobile.closest('section.shopify-section');
      if (jdgmSectionMobile) jdgmSectionMobile.style.display = 'none';
      var featElForJdgm = document.getElementById('njoy-feat-section-' + NJOY_SID + '');
      if (featElForJdgm) {
        featElForJdgm.insertAdjacentElement('beforebegin', jdgmMobile);
      } else {
        reviews.insertAdjacentElement('beforebegin', jdgmMobile);
      }
    }
    return;
  }

  var productInfo = document.querySelector('.product__info-container');
  if (!productInfo) return;
  var originalSection = reviews.closest('section.shopify-section');
  if (originalSection) originalSection.style.display = 'none';
  var pdesc = productInfo.querySelector('.njoy-pdesc');
  var viewDetails = productInfo.querySelector('.product__view-details');
  if (pdesc) {
    pdesc.insertAdjacentElement('afterend', reviews);
  } else if (viewDetails) {
    productInfo.insertBefore(reviews, viewDetails);
  } else {
    productInfo.appendChild(reviews);
  }
  // Cột sticky hẹp hơn vị trí gốc của review section → phải đo lại line-clamp
  // ("Xem thêm") ở chiều rộng MỚI, nếu không nút bị thiếu cho review đủ dài để
  // tràn 2 dòng chỉ SAU khi đã thu hẹp vào đây.
  if (window.njoyReviewsRecheckExpand) window.njoyReviewsRecheckExpand();

  // ── Move Judge.me widget xuống cột trái, nằm NGAY TRÊN "Thông tin nổi bật"
  // (featEl) — khớp đúng vị trí đã đổi trên mobile (review lên trước, thông số
  // kỹ thuật xuống sau, theo yêu cầu Nick). Trước đây appendChild xuống CUỐI
  // cột trái (dưới cả mô tả sản phẩm) — không khớp mobile. ──
  var jdgm = document.getElementById('judgeme_product_reviews');
  if (jdgm) {
    var jdgmSection = jdgm.closest('section.shopify-section');
    if (jdgmSection) jdgmSection.style.display = 'none';
    var leftColJdgm = document.querySelector('.njoy-2col__left');
    var featElDesktop = document.getElementById('njoy-feat-section-' + NJOY_SID + '');
    if (featElDesktop) {
      featElDesktop.insertAdjacentElement('beforebegin', jdgm);
    } else if (leftColJdgm) {
      leftColJdgm.appendChild(jdgm);
    } else {
      reviews.insertAdjacentElement('afterend', jdgm);
    }
  }
});

// ── Đánh giá: thẻ tóm tắt ngoài trang + bảng mở xem tất cả (Nick 28/10). Đăng ký SAU njoyMoveReviews
// → widget đã nằm đúng chỗ (trên "Thông tin nổi bật"); thẻ chiếm chỗ đó, widget Judge.me (Vue, đã mount)
// dời nguyên vào bảng — các observer/style bám #judgeme_product_reviews bên dưới vẫn chạy như cũ.
// Thông minh: thẻ tự lấy tối đa 3 nhận xét CÓ CHỮ của trang 1; bấm nhận xét nào thì bảng cuộn tới đúng
// nhận xét đó; vuốt xuống / nút Back của điện thoại đóng bảng; link có #danh-gia mở thẳng bảng. ──
document.addEventListener('DOMContentLoaded', function njoyReviewSheet() {
  var jdgm = document.getElementById('judgeme_product_reviews');
  if (!jdgm || document.getElementById('njoy-rv-card')) return;
  var STAR = '<svg class="njoy-rv-star" viewBox="0 0 20 20" aria-hidden="true"><path d="M10 1.5l2.59 5.25 5.79.84-4.19 4.08.99 5.77L10 14.77l-5.18 2.67.99-5.77L1.62 7.6l5.79-.84L10 1.5z"/></svg>';
  var CLOSE = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>';
  var EMPTY = 'Khách hàng không để lại nhận xét';
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  // Điểm sao lấy từ hàng giá (custom.shopee_rating) — cùng nguồn với chip cũ cạnh tiêu đề
  var scoreEl = document.querySelector('.njoy-info-preview .njoy-stat-score');
  var score = scoreEl ? scoreEl.textContent.trim() : '';
  var chip = score ? '<span class="njoy-jdgm-rating">' + STAR + esc(score) + '</span>' : '';

  var card = document.createElement('div');
  card.id = 'njoy-rv-card';
  card.className = 'njoy-rv-card';
  card.setAttribute('role', 'button');
  card.setAttribute('tabindex', '0');
  card.setAttribute('aria-haspopup', 'dialog');
  card.innerHTML =
    '<div class="njoy-rv-card__head">' + chip +
      '<span class="njoy-rv-card__title">Đánh giá sản phẩm</span>' +
      '<span class="njoy-rv-card__more">Xem tất cả</span>' +
    '</div>' +
    '<div class="njoy-rv-card__strip"></div>';
  // Thẻ luôn nằm ngay trên "Thông tin nổi bật" — kể cả SP không có khối #njoy-product-reviews (njoyMoveReviews
  // thoát sớm, widget còn ở section Judge.me cuối trang). SP không có "Thông tin nổi bật" → đặt trên "Mô tả
  // sản phẩm". Section Judge.me gốc ẩn đi vì widget đã vào bảng.
  var feat = document.getElementById('njoy-feat-section-' + NJOY_SID + '');
  var pdesc = document.querySelector('.njoy-pdesc');
  var origSec = jdgm.closest('section.shopify-section');
  if (feat) feat.insertAdjacentElement('beforebegin', card);
  else if (pdesc) pdesc.insertAdjacentElement('beforebegin', card);
  else jdgm.insertAdjacentElement('beforebegin', card);
  if (origSec && !origSec.contains(card)) origSec.style.display = 'none';
  if (card.getBoundingClientRect().left < 8) card.classList.add('njoy-rv-card--pad'); // nằm sát mép màn hình → tự thêm lề

  var sheet = document.createElement('div');
  sheet.className = 'njoy-rv-sheet';
  sheet.innerHTML =
    '<div class="njoy-rv-sheet__ov" data-rv-close></div>' +
    '<div class="njoy-rv-sheet__panel" role="dialog" aria-modal="true" aria-label="Đánh giá sản phẩm">' +
      '<div class="njoy-rv-sheet__head"><span class="njoy-rv-sheet__grab" aria-hidden="true"></span>' +
        '<div class="njoy-rv-sheet__row">' + chip +
          '<span class="njoy-rv-sheet__title">Đánh giá sản phẩm<span class="njoy-rv-sheet__count"></span></span>' +
          '<button type="button" class="njoy-rv-sheet__x" data-rv-close aria-label="Đóng">' + CLOSE + '</button>' +
        '</div>' +
      '</div>' +
      '<div class="njoy-rv-sheet__body"></div>' +
    '</div>';
  document.body.appendChild(sheet);
  var panel = sheet.querySelector('.njoy-rv-sheet__panel');
  var body = sheet.querySelector('.njoy-rv-sheet__body');
  var head = sheet.querySelector('.njoy-rv-sheet__head');
  body.appendChild(jdgm);

  // Judge.me vẽ bằng Vue (async) → điền số đánh giá + nhận xét mẫu khi widget có dữ liệu
  var built = false;
  function fill() {
    var more = card.querySelector('.njoy-rv-card__more');
    if (jdgm.querySelector('.jm-no-reviews-state')) {
      card.classList.add('is-empty');
      more.textContent = 'Viết đánh giá';
      return;
    }
    var n = 0;
    jdgm.querySelectorAll('.jm-average-rating-display .jm-text').forEach(function (p) {
      var m = p.textContent.match(/(\d[\d.,]*)\s*(đánh giá|review)/i);
      if (m) n = parseInt(m[1].replace(/\D/g, ''), 10);
    });
    if (!n) return;
    card.classList.remove('is-empty');
    more.textContent = n + ' đánh giá';
    sheet.querySelector('.njoy-rv-sheet__count').textContent = ' (' + n + ')';
    if (built) return;
    var items = jdgm.querySelectorAll('.jm-review-item');
    if (!items.length) return;
    built = true;
    var html = '', k = 0;
    items.forEach(function (it) {
      if (k >= 3) return;
      var t = it.querySelector('.jdgm-review-content__body-content');
      t = t ? t.textContent.replace(/\s+/g, ' ').trim() : '';
      if (!t || t === EMPTY) return;
      var sr = it.querySelector('.jm-star-rating');
      var r = Math.min(5, Math.max(1, parseInt(sr && sr.getAttribute('aria-label'), 10) || 5));
      var nm = it.querySelector('.jm-reviewer-info__name');
      html += '<div class="njoy-rv-snip" data-uuid="' + esc(it.getAttribute('review-uuid') || '') + '">' +
        '<div class="njoy-rv-snip__meta"><span class="njoy-rv-snip__stars">' + new Array(r + 1).join(STAR) + '</span>' +
        '<span>' + esc(nm ? nm.textContent.trim() : '') + '</span></div>' +
        '<p class="njoy-rv-snip__text">' + esc(t) + '</p></div>';
      k++;
    });
    var strip = card.querySelector('.njoy-rv-card__strip');
    strip.innerHTML = html;
    strip.classList.toggle('is-single', k === 1);
  }
  fill();
  var fillQueued = false;
  new MutationObserver(function () {
    if (fillQueued) return;
    fillQueued = true;
    requestAnimationFrame(function () { fillQueued = false; fill(); });
  }).observe(jdgm, { childList: true, subtree: true, characterData: true });

  var lastFocus = null, pushed = false;
  function isOpen() { return sheet.classList.contains('is-open'); }
  function open(uuid) {
    if (isOpen()) return;
    lastFocus = document.activeElement;
    document.documentElement.classList.add('njoy-rv-lock');
    sheet.classList.add('is-open');
    body.scrollTop = 0;
    try { history.pushState({ njoyRv: 1 }, ''); pushed = true; } catch (e) {}
    if (uuid) {
      var it = jdgm.querySelector('.jm-review-item[review-uuid="' + uuid + '"]');
      if (it) requestAnimationFrame(function () {
        var hd = jdgm.querySelector('.jm-review-widget__header');
        body.scrollTop += it.getBoundingClientRect().top - body.getBoundingClientRect().top - (hd ? hd.offsetHeight : 0) - 8;
        it.classList.remove('njoy-rv-hl'); void it.offsetWidth; it.classList.add('njoy-rv-hl');
      });
    }
    setTimeout(function () { var x = sheet.querySelector('.njoy-rv-sheet__x'); if (x) x.focus({ preventScroll: true }); }, 60);
  }
  function close(fromPop) {
    if (!isOpen()) return;
    panel.style.transition = '';
    panel.style.transform = '';
    sheet.classList.remove('is-open');
    document.documentElement.classList.remove('njoy-rv-lock');
    if (pushed && !fromPop) history.back();
    pushed = false;
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }
  window.njoyOpenReviews = open;
  window.addEventListener('popstate', function () { if (isOpen()) close(true); });

  card.addEventListener('click', function (e) {
    // Chưa có đánh giá → mở thẳng form viết đánh giá của Judge.me (nằm trên bảng, z 9999)
    var write = card.classList.contains('is-empty') && jdgm.querySelector('[data-testid="write-review-button"]');
    if (write) { write.click(); return; }
    var sn = e.target.closest('.njoy-rv-snip');
    open(sn ? sn.getAttribute('data-uuid') : '');
  });
  card.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); card.click(); }
  });
  sheet.addEventListener('click', function (e) {
    if (e.target.closest('[data-rv-close]')) { close(); return; }
    if (e.target.closest('.jm-pagination-controls__button--nav')) body.scrollTo({ top: 0, behavior: 'smooth' });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape' || !isOpen()) return;
    var jm = document.querySelector('.jdgm-review-widget-modal');
    if (jm && jm.getClientRects().length) return; // form viết đánh giá đang mở → để Judge.me tự đóng trước
    close();
  });

  // Vuốt thanh đầu bảng xuống để đóng (mobile)
  var y0 = null, dy = 0;
  head.addEventListener('touchstart', function (e) {
    if (e.target.closest('button')) return;
    y0 = e.touches[0].clientY; dy = 0;
    panel.style.transition = 'none';
  }, { passive: true });
  head.addEventListener('touchmove', function (e) {
    if (y0 === null) return;
    dy = Math.max(0, e.touches[0].clientY - y0);
    panel.style.transform = 'translateY(' + dy + 'px)';
  }, { passive: true });
  head.addEventListener('touchend', function () {
    if (y0 === null) return;
    y0 = null;
    panel.style.transition = '';
    if (dy > 80) close(); else panel.style.transform = '';
  });

  if (/^#(danh-gia|reviews)$/.test(location.hash)) open();
});

// ── Đổi title widget Judge.me "Đánh giá của Khách hàng" → "Đánh giá từ Khách
// Hàng" (khớp chữ với khối review cũ) — áp dụng mọi viewport (không chỉ
// desktop). Judge.me render bằng Vue nên title chưa tồn tại lúc DOMContentLoaded,
// phải dùng MutationObserver theo dõi #judgeme_product_reviews. ──
document.addEventListener('DOMContentLoaded', function () {
  var OLD_TITLE = 'Đánh giá của Khách hàng';
  var NEW_TITLE = 'Đánh giá sản phẩm';
  var container = document.getElementById('judgeme_product_reviews');
  if (!container) return;
  function fixTitles() {
    container.querySelectorAll('.jm-review-widget-minimal-header__title').forEach(function (el) {
      if (el.textContent.trim() === OLD_TITLE) el.textContent = NEW_TITLE;
    });
  }

  // ── Đổi chữ nút "Viết đánh giá" → "Đánh giá sản phẩm" (text đến từ setting
  // account-level của Judge.me, không sửa được qua theme — cùng kỹ thuật
  // text-replace như fixTitles). ──
  function fixWriteReviewText() {
    var btn = container.querySelector('[data-testid="write-review-button"]');
    if (btn && btn.textContent.trim() === 'Viết đánh giá') btn.textContent = 'Đánh giá sản phẩm';
  }

  // ── Đổi chữ nút "Thêm" (mở rộng review dài) → "Xem thêm", khớp njoy-pr-more.
  // Sửa text của <p> con, KHÔNG sửa textContent của button — nếu không sẽ xoá
  // mất thẻ <p class="jm-text"> bên trong, làm hỏng CSS đang nhắm vào nó. ──
  function fixExpandButtonText() {
    container.querySelectorAll('.jm-review-content__expand-button .jm-text').forEach(function (el) {
      if (el.textContent.trim() === 'Thêm') el.textContent = 'Xem thêm';
    });
  }

  // ── Chuyển rating của TỪNG review → 5 icon sao (đầy/rỗng theo rating),
  // khớp njoy-pr-stars. Đọc rating từ aria-label "X out of 5 stars" (Judge.me
  // tự set), không đụng logic tính rating — chỉ đổi cách HIỂN THỊ. ──
  var STAR_PATH = 'M10 1.5l2.59 5.25 5.79.84-4.19 4.08.99 5.77L10 14.77l-5.18 2.67.99-5.77L1.62 7.6l5.79-.84L10 1.5z';
  var FILLED_STAR_SVG = '<svg width="14" height="14" viewBox="0 0 20 20" aria-hidden="true" style="fill:#f5a623;flex-shrink:0;"><path d="' + STAR_PATH + '"/></svg>';
  var EMPTY_STAR_SVG = '<svg width="14" height="14" viewBox="0 0 20 20" aria-hidden="true" style="fill:none;stroke:#ddd;stroke-width:1.3;flex-shrink:0;"><path d="' + STAR_PATH + '"/></svg>';
  function convertStars() {
    container.querySelectorAll('.jm-star-rating[role="img"][aria-label]').forEach(function (el) {
      if (el.dataset.njoyStarConverted) return;
      var m = /^(\d+(?:\.\d+)?)/.exec(el.getAttribute('aria-label') || '');
      if (!m) return;
      el.dataset.njoyStarConverted = '1';
      var rating = Math.round(parseFloat(m[1]));
      var html = '';
      for (var i = 0; i < 5; i++) html += i < rating ? FILLED_STAR_SVG : EMPTY_STAR_SVG;
      el.innerHTML = html;
      el.style.display = 'inline-flex';
      el.style.alignItems = 'center';
      el.style.gap = '2px';
    });
  }

  // ── Pagination: ẩn dãy số trang bấm được, thay bằng chữ "N / M" ở giữa 2
  // nút mũi tên tròn (CSS lo phần khung/nút, xem njoy-core.css) — Judge.me
  // không có sẵn định dạng "N / M", phải tự tính từ số nút trang + nút active. ──
  function stylePagination() {
    var nav = container.querySelector('.jm-pagination-controls');
    if (!nav) return;
    var pageButtons = nav.querySelectorAll('.jm-pagination-controls__button--page');
    if (!pageButtons.length) return;
    var active = nav.querySelector('.jm-pagination-controls__button--active');
    if (!active) return;
    pageButtons.forEach(function (b) { b.style.display = 'none'; });
    var label = nav.querySelector('.njoy-jdgm-page-label');
    if (!label) {
      label = document.createElement('span');
      label.className = 'njoy-jdgm-page-label jm-text';
      pageButtons[0].insertAdjacentElement('beforebegin', label);
    }
    var text = active.textContent.trim() + ' / ' + pageButtons.length;
    if (label.textContent !== text) label.textContent = text;
  }

  // ── Icon mũi tên prev/next — Judge.me tự render SVG filled-path riêng,
  // đổi sang polyline stroke khớp .njoy-recs__nav-btn (njoy-product-recs.liquid)
  // theo yêu cầu Nick. Chỉ đổi được qua JS (thay nội dung SVG), CSS không thể
  // biến filled-path thành stroke-path khác hình dạng. ──
  function styleNavIcons() {
    container.querySelectorAll('.jm-pagination-controls__button--nav').forEach(function (btn) {
      if (btn.dataset.njoyIconReplaced) return;
      var svg = btn.querySelector('svg');
      if (!svg) return;
      btn.dataset.njoyIconReplaced = '1';
      var isPrev = btn.getAttribute('aria-label') === 'Go to previous page';
      svg.setAttribute('width', '14');
      svg.setAttribute('height', '14');
      svg.setAttribute('viewBox', '0 0 24 24');
      svg.setAttribute('fill', 'none');
      svg.setAttribute('stroke', 'currentColor');
      svg.setAttribute('stroke-width', '2.5');
      svg.setAttribute('stroke-linecap', 'round');
      svg.setAttribute('stroke-linejoin', 'round');
      svg.innerHTML = '<polyline points="' + (isPrev ? '15 18 9 12 15 6' : '9 18 15 12 9 6') + '"></polyline>';
    });
  }

  // ── Nút "Đánh giá sản phẩm" → thu gọn thành icon (bút chì), dời lên nằm
  // NGAY CẠNH tiêu đề "Đánh giá từ Khách Hàng" (thay vì hiện đầy đủ chữ ở cuối
  // section) — Nick chốt: khách nhìn icon vẫn hiểu đúng hành động, đỡ tốn
  // chỗ + rút ngắn chiều cao section. Giữ text gốc qua aria-label/title (đọc
  // được cho screen reader + tooltip hover) — không mất thông tin, chỉ đổi
  // cách hiển thị. Bọc title vào 1 row flex riêng để icon nằm cùng hàng (title
  // gốc nằm trong 1 jm-stack dọc — không thể chỉ chèn sibling mà tự nằm ngang). ──
  var WRITE_REVIEW_ICON = '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path></svg>';
  function iconifyWriteReviewButton() {
    var btn = container.querySelector('[data-testid="write-review-button"]');
    var title = container.querySelector('.jm-review-widget-minimal-header__title');
    if (!btn || !title || btn.dataset.njoyIconified) return;
    btn.dataset.njoyIconified = '1';

    var label = btn.textContent.trim() || 'Đánh giá sản phẩm';
    btn.setAttribute('aria-label', label);
    btn.setAttribute('title', label);
    btn.classList.add('njoy-jdgm-write-icon');
    btn.innerHTML = WRITE_REVIEW_ICON;

    var row = document.createElement('div');
    row.className = 'njoy-jdgm-title-row';
    title.insertAdjacentElement('beforebegin', row);
    // Sao + điểm (từ Shopee, custom.shopee_rating) đứng TRƯỚC tiêu đề — mobile đã bỏ khỏi hàng giá (Nick 28/10)
    var score = document.querySelector('.njoy-info-preview .njoy-stat-score');
    var star = score && score.querySelector('svg.njoy-star');
    if (score && score.textContent.trim() && star) {
      var chip = document.createElement('span');
      chip.className = 'njoy-jdgm-rating';
      chip.appendChild(star.cloneNode(true));
      chip.appendChild(document.createTextNode(score.textContent.trim()));
      row.appendChild(chip);
    }
    row.appendChild(title);
    row.appendChild(btn);
  }

  function swapPagination() {
    var nav = container.querySelector('.jm-pagination-controls');
    // Chèn thẳng vào hàng ngoài cùng (cùng cấp với title-stack, dùng chung
    // space-between của hàng đó) — KHÔNG chèn vào .jm-action-buttons như bản
    // cũ, vì wrapper đó nằm trong .jm-review-widget-minimal-header__filter-container
    // (1 .jm-stack không tự giãn hết chiều rộng còn lại) → flex-end bên trong
    // chỉ đẩy nav sát mép của box hẹp đó, không chạm mép phải THẬT của hàng
    // (đo được hụt ~32px qua debug). Chèn thẳng vào outerCluster + ẩn hẳn
    // filter-container rỗng thì space-between tự đẩy nav sát mép phải thật.
    var outerCluster = container.querySelector('.jm-review-widget__header > .jm-cluster');
    if (!nav || !outerCluster || nav.dataset.njoySwapped) return;
    nav.dataset.njoySwapped = '1';
    outerCluster.appendChild(nav);
  }

  // ── Ẩn dòng "Khách hàng không để lại nhận xét" (placeholder Judge.me tự
  // chèn khi review gốc từ Shopee/nguồn khác không có text) — chỉ có
  // rating, không có nhận xét thật thì không cần chiếm chỗ hiển thị câu
  // placeholder vô nghĩa này. Ẩn cả .jm-review-body-wrapper (không chỉ text)
  // để không để lại khoảng trắng dư trong stack layout. ──
  var EMPTY_REVIEW_TEXT = 'Khách hàng không để lại nhận xét';
  function hideEmptyReviewText() {
    container.querySelectorAll('.jdgm-review-content__body-content').forEach(function (el) {
      var wrapper = el.closest('.jm-review-body-wrapper');
      if (!wrapper) return;
      var isEmpty = el.textContent.trim() === EMPTY_REVIEW_TEXT;
      wrapper.style.display = isEmpty ? 'none' : '';
      // Đánh dấu class trên chính .jm-review-item — dùng để CSS giảm
      // margin-top riêng cho review không có nhận xét (xem njoy-core.css),
      // không dựa vào :has() + inline style dễ vỡ khi Judge.me đổi cách set.
      var item = el.closest('.jm-review-item');
      if (item) item.classList.toggle('njoy-review-item--empty', isEmpty);
    });
  }

  // ── Rút gọn ngày review từ "MM/DD/YYYY" (định dạng Judge.me tự render) →
  // "MM/YY" — Nick yêu cầu, đỡ chiếm chỗ trên hàng info giờ đã gộp chung với
  // sao đánh giá. dataset guard tránh xử lý lại (regex không còn khớp sau lần
  // đầu vì đã rút gọn). ──
  function shortenReviewDates() {
    container.querySelectorAll('.jm-reviewer-info__details .jm-text:not(.jm-reviewer-info__name)').forEach(function (el) {
      if (el.dataset.njoyDateShortened) return;
      var m = /^(\d{2})\/(\d{2})\/(\d{4})$/.exec(el.textContent.trim());
      if (!m) return;
      el.dataset.njoyDateShortened = '1';
      el.textContent = m[1] + '/' + m[3].slice(2);
    });
  }

  // ── Icon "verified" kế bên tên+ngày — hover hiện tooltip ngắn báo đánh giá
  // đồng bộ từ sàn TMĐT (review thật lấy từ Shopee, không phải khách viết
  // trực tiếp trên Shopify) — minh bạch nguồn gốc, đồng thời "lấp" khoảng
  // trống cho review không có nhận xét (xem hideEmptyReviewText) mà không
  // cần thêm câu chữ giải thích sự thiếu vắng đó. Chèn VÀO TRONG cluster của
  // ngày (không làm sibling rời của .jm-reviewer-info__details) để không phá
  // rule ::before dấu "·" đang dựa vào :last-child. ──
  var VERIFIED_SVG = '<svg width="13" height="13" viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="12" fill="#9a9a9a"/><path d="M7 12.5l3 3 7-7" stroke="#fff" stroke-width="2.2" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var VERIFIED_TEXT = 'Đánh giá đồng bộ từ sàn TMĐT';
  function addVerifiedBadge() {
    container.querySelectorAll('.jm-reviewer-info__details').forEach(function (el) {
      if (el.querySelector('.njoy-jdgm-verified')) return;
      var dateCluster = el.lastElementChild;
      if (!dateCluster) return;
      var badge = document.createElement('span');
      badge.className = 'njoy-jdgm-verified';
      // title = fallback cho desktop hover — KHÔNG đủ trên mobile (68% traffic)
      // vì title chỉ phản hồi hover chuột, tap/click không kích hoạt được
      // (Nick báo bấm vào không thấy gì). Tooltip thật hiện qua click handler
      // riêng bên dưới (xem njoyShowVerifiedTooltip). ──
      badge.title = VERIFIED_TEXT;
      badge.innerHTML = VERIFIED_SVG;
      dateCluster.appendChild(badge);
    });
  }

  // ── Tooltip tự làm cho badge verified — bấm/tap hiện bong bóng nhỏ phía
  // trên icon trong ~2.2s rồi tự ẩn, hoặc ẩn ngay nếu bấm chỗ khác. Dùng 1
  // element tooltip DÙNG CHUNG (không tạo mới mỗi review) + event delegation
  // trên document để bắt được cả badge sinh ra sau qua MutationObserver. ──
  var njoyVerifiedTooltipEl = null;
  var njoyVerifiedTooltipTimer = null;
  function njoyShowVerifiedTooltip(badge) {
    if (!njoyVerifiedTooltipEl) {
      njoyVerifiedTooltipEl = document.createElement('div');
      njoyVerifiedTooltipEl.className = 'njoy-jdgm-verified-tip';
      document.body.appendChild(njoyVerifiedTooltipEl);
    }
    njoyVerifiedTooltipEl.textContent = VERIFIED_TEXT;
    var r = badge.getBoundingClientRect();
    njoyVerifiedTooltipEl.style.display = 'block';
    var tipW = njoyVerifiedTooltipEl.offsetWidth;
    var left = r.left + r.width / 2 - tipW / 2;
    left = Math.max(8, Math.min(left, window.innerWidth - tipW - 8));
    njoyVerifiedTooltipEl.style.left = left + 'px';
    njoyVerifiedTooltipEl.style.top = (r.top - njoyVerifiedTooltipEl.offsetHeight - 8) + 'px';
    clearTimeout(njoyVerifiedTooltipTimer);
    njoyVerifiedTooltipTimer = setTimeout(function () {
      njoyVerifiedTooltipEl.style.display = 'none';
    }, 2200);
  }
  document.addEventListener('click', function (e) {
    var badge = e.target.closest ? e.target.closest('.njoy-jdgm-verified') : null;
    if (badge) {
      e.stopPropagation();
      njoyShowVerifiedTooltip(badge);
      return;
    }
    if (njoyVerifiedTooltipEl && njoyVerifiedTooltipEl.style.display === 'block') {
      njoyVerifiedTooltipEl.style.display = 'none';
    }
  });

  function runFixes() { fixTitles(); fixWriteReviewText(); fixExpandButtonText(); convertStars(); stylePagination(); styleNavIcons(); iconifyWriteReviewButton(); swapPagination(); hideEmptyReviewText(); shortenReviewDates(); addVerifiedBadge(); }
  runFixes();
  new MutationObserver(runFixes).observe(container, { childList: true, subtree: true, characterData: true });
});

// ── Chuyển trang review mượt, không giật (Judge.me pagination gốc, KHÔNG
// phải bản gom-4-review-tự-vẽ đã gỡ vì làm chậm). Lịch sử các lần chỉnh
// trước đều còn lỗi: (1) khoá min-height ở mức cao nhất → để lại khoảng
// trắng to khi trang mới ngắn hơn; (2) animate CHIỀU CAO trong lúc content
// vẫn đang hiện → giật; (3) chỉ animate opacity, dùng MutationObserver để
// biết khi nào nội dung mới đã về — NHƯNG root cause thật (verify qua
// console.log trực tiếp, không đoán): Judge.me tự đổi 1 thuộc tính DOM nhỏ
// trên nút bấm ngay lúc mousedown (trước khi 'click' bắn ra) → observer bắt
// nhầm đây là "nội dung đã đổi", gọi fadeIn() SỚM trong lúc fade-out (do
// click handler set) vẫn đang chạy → 2 đoạn code tranh nhau ghi đè opacity,
// có lúc bị đứng hình (không phản ứng khi bấm icon) đúng như Nick báo. Fix
// đúng: onContentChanged() không tin BẤT KỲ mutation nào nữa — tự so sánh
// danh sách review-uuid thực tế, CHỈ coi là "trang đã đổi thật" khi tập
// review-uuid khác lần trước (mutation về nút bấm không đổi được cái này). ──
document.addEventListener('DOMContentLoaded', function () {
  var container = document.getElementById('judgeme_product_reviews');
  if (!container) return;
  var fadeOutDone = true; // lần đầu load, chưa cần chờ gì
  var contentReady = false;
  var lastSig = null;

  function fadeIn(list) {
    if (!fadeOutDone || !contentReady) return;
    contentReady = false;
    // Đổi height NGAY, KHÔNG transition — vô hại vì lúc này opacity đang ở 0.
    list.style.transition = 'none';
    list.style.height = 'auto';
    void list.offsetHeight;
    list.style.transition = 'opacity .25s ease';
    requestAnimationFrame(function () { list.style.opacity = '1'; });
  }

  function onContentChanged() {
    var list = container.querySelector('.jdgm-review-list');
    if (!list) return;
    var items = list.querySelectorAll('.jm-review-item');
    if (!items.length) return;
    var sig = Array.prototype.map.call(items, function (el) { return el.getAttribute('review-uuid'); }).join(',');
    if (sig === lastSig) return; // mutation không liên quan (VD trạng thái nút bấm) — bỏ qua
    lastSig = sig;
    contentReady = true;
    fadeIn(list);
  }
  onContentChanged();
  new MutationObserver(onContentChanged).observe(container, { childList: true, subtree: true });

  // Bấm next/prev (kể cả nút gốc Judge.me lẫn nút mũi tên NJoy đã đổi icon) →
  // fade về 0, CHỜ transitionend thật (không đoán thời gian) mới coi là xong,
  // rồi mới cho phép fadeIn() chạy — đảm bảo luôn có khoảng lặng rõ ràng giữa
  // 2 chiều, không còn chồng chéo/giật.
  container.addEventListener('click', function (e) {
    var btn = e.target.closest('.jm-pagination-controls__button--nav');
    if (!btn) return;
    var list = container.querySelector('.jdgm-review-list');
    if (!list) return;
    fadeOutDone = false;
    list.style.transition = 'opacity .15s ease';
    list.style.opacity = '0';
    list.addEventListener('transitionend', function onEnd(e2) {
      if (e2.propertyName !== 'opacity') return;
      list.removeEventListener('transitionend', onEnd);
      fadeOutDone = true;
      fadeIn(list);
    });
  });
});

// ── Đổi text title trang 1 modal viết đánh giá (.jdgm-write-review-modal,
// portal riêng ra ngoài body — KHÔNG nằm trong #judgeme_product_reviews nên
// không dùng chung container/observer ở trên) — theo yêu cầu Nick, ngắn gọn
// hơn bản gốc Judge.me. BUG đã gặp + fix: quan sát 1 node modal cụ thể (kể cả
// tìm lại sau khi chờ body) KHÔNG đủ — bấm nút mở modal xong text quay lại
// bản gốc, nghi Judge.me thay hẳn node mới (không chỉ đổi text) mỗi lần mở
// thật. Dùng querySelector TƯƠI mỗi lần observer body bắn (không giữ
// reference cũ) + observe body vĩnh viễn (không disconnect) cho chắc, hàm
// rất nhẹ nên không đáng ngại hiệu năng. ──
document.addEventListener('DOMContentLoaded', function () {
  var OLD_MODAL_TITLE = 'Bạn đánh giá sản phẩm này như thế nào?';
  var NEW_MODAL_TITLE = 'Để lại đánh giá';
  function fixModalTitle() {
    var el = document.querySelector('.jdgm-write-review-modal__title');
    if (el && el.textContent.trim() === OLD_MODAL_TITLE) el.textContent = NEW_MODAL_TITLE;
  }
  fixModalTitle();
  new MutationObserver(fixModalTitle).observe(document.body, { childList: true, subtree: true, characterData: true });
});
